<template>
  <div>
    <!-- Section 1 -->
    <section class="hero-welcome flex justify-center flex-col md:mx-12 mx-6">
    </section>
    <div class="flex py-8 font-bold text-4xl text-center">
      <span class="text-center w-full">Saravá Xangô!</span>
    </div>
  </div>

  <main>
    <HomeWhatWeDo />
    <HomeTestimonials />

    <HomeEventsHeld />
 
    <section class="mx-auto mt-32 ">
      <HomeBlogSection />
    </section>
  </main>

</template>

<script setup lang="ts">
// -------------------------------------------
// Hooks
// -------------------------------------------

const { t } = useI18n();

useHead({
  title: t('NAME'),
  titleTemplate: 'Terreiro de Umbanda Vó Rita das Almas'
});
</script>
<style lang="scss">

</style>

<style lang="scss" scoped>
main {
  background-color: #fff;
}

.hero-welcome {
  background-color: #fff;
  overflow: hidden;
  position: relative;
  background-position: center 30%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('https://assets.terreirovoritadasalmas.com.br/illustrations/hero-welcome.jpg');
  height: 800px;

  p {
    z-index: 1;
    text-shadow: 0px 0px 60px #000;
  }
}

main section {
  max-width: 1600px;
}

.what-we-do {
  max-width: 1600px;

  > div > div {
    flex: 1;
    width: 50%;
  }
}
</style>